<template>
    <div>
        <v-btn
            v-if="!noButton"
            :color="buttonColor"
            :round="buttonRound"
            :large="buttonLarge"
            @click="onPay"
            :loading="loading"
        >
            {{ 'Pay' | translation }}{{ feeText }}
        </v-btn>
    </div>
</template>

<script>
import Vue from 'vue';
import { VorauskassePaymentType } from './config';
import gql from 'graphql-tag';
import { mapGetters, mapMutations, mapState } from 'vuex';

const moduleName = 'VorauskassePaymentType';

export default {
    name: moduleName,
    props: {
        noButton: Boolean,
        buttonLarge: Boolean,
        buttonRound: Boolean,
        buttonColor: {
            type: String,
            default: 'primary',
        },
    },
    data() {
        return {
            loading: false,
            fees: {},
        };
    },
    created() {
        return Vue.$graphql
            .query({
                query: gql`
                    query vorauskasseGetPaymentFee {
                        vorauskasseGetPaymentFee {
                            paymentFee
                            paymentFeeGermany
                            paymentFeeChf
                        }
                    }
                `,
                fetchPolicy: 'no-cache',
            })
            .then(r => r.data.vorauskasseGetPaymentFee)
            .then(result => {
                this.fees = result;
            })
            .catch(() => {
                this.fees = {};
            });
    },
    computed: {
        ...mapGetters('Payment', ['calculateOrderPaymentFee']),
        ...mapState('Coupon', ['paidCouponAmount']),
        feeText() {
            let paymentFee = this.fees.paymentFee;
            if (this.$currency.getSelected() === 'CHF') {
                paymentFee = this.fees.paymentFeeChf;
            } else if (this.$country.getCountry() === 'DE') {
                paymentFee = this.fees.paymentFeeGermany;
            }
            if (paymentFee) {
                const paymentNameParts = [];
                paymentNameParts.push(' ');
                paymentNameParts.push('(');
                if (paymentFee.includes('%')) {
                    paymentNameParts.push(`${paymentFee} = `);
                }
                const basketTotal = this.$basket.getBasketTotal();
                if (this.paidCouponAmount) {
                    paymentFee = this.calculateOrderPaymentFee(basketTotal - this.paidCouponAmount, paymentFee);
                } else {
                    paymentFee = this.calculateOrderPaymentFee(basketTotal, paymentFee);
                }
                paymentNameParts.push(this.$root.$options.filters.currency(paymentFee));
                paymentNameParts.push(')');
                return paymentNameParts.join('');
            }
        },
    },
    methods: {
        ...mapMutations('Payment', ['setError']),
        onPay() {
            this.loading = true;
            this.$order.getOrder().then(order => {
                if (order && order.id) {
                    Vue.$graphql
                        .mutate({
                            mutation: gql`
                                mutation vorauskasseExecutePayment($orderId: Int!, $transactionId: String!) {
                                    vorauskasseExecutePayment(orderId: $orderId, transactionId: $transactionId) {
                                        success
                                    }
                                }
                            `,
                            variables: {
                                orderId: parseInt(order.id),
                                transactionId: order.transaction_id,
                            },
                        })
                        .then(() => {
                            this.$router.replace({
                                ...this.$route,
                                query: {},
                            });

                            this.$emit('success', order);
                        })
                        .catch(e => {
                            this.loading = false;
                            console.error(e.toString());
                        });
                } else {
                    this.loading = false;

                    this.setError('Order not created, please try again later.');
                }
            });
        },
    },
    install(Vue) {
        Vue.component(moduleName, this);
        Vue.$store.commit('Payment/addPaymentType', new VorauskassePaymentType());
    },
};
</script>
